import { CrudServiceBase } from '@utils';
import { CarListBand } from './car-list-band.class';

export class CarListBandService extends CrudServiceBase<CarListBand> {
	constructor() {
		super(CarListBand, 'organization/segments', { getAllPath: 'segment' });
	}
}

export const carListBandService = new CarListBandService();
